












































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { domain, User, Company, PartialPermission, EditPermission, EditUser, VueRoot, FilteredBranch } from "@/domain";
import QuickSnack from "@/components/QuickSnack.vue";
import QrCodeImg from "@/components/QrCodeImg.vue";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import { getUserStartPage } from "@/modules/router";
import * as lodash from "lodash";
import { normalize } from "@/util";
import { navigateToTerminal } from "@/uiUtil";

interface FilterCompanyResult {
  companies: Company[];
  morePages: boolean;
  total: number;
}

@Component({
  components: { QuickSnack, QrCodeImg }
})
export default class CompanyCatalog extends Vue {
  snackbar = "";
  txtCompanySearch = "";
  searchByCompany = "";
  txtBranchSearch = "";
  searchByBranch = "";
  removingCompany: Company | null = null;
  fiterBy: "company" | "branch" = "company";
  pageCount = 0;

  get lang() {
    return this.$store.state.lang.data;
  }

  get lastRemoteError(): string | null {
    if (this.$store.state.lastError) {
      return this.lang.errorData;
    }
    return null;
  }

  get userCompaniesLoading(): boolean {
    return this.$store.state.userCompaniesLoading;
  }

  get userCompanies(): Company[] | null {
    return this.$store.state.userCompanies;
  }

  get filteredCompanies(): FilterCompanyResult | null {
    if (!this.userCompanies) {
      return null;
    }
    const companies = util.searchTermFilter(this.userCompanies, this.searchByCompany, (c) => c.name);
    if (this.fiterBy === "company") return this.sliceCompanyResult(companies);
    const branchTerm = normalize(this.searchByBranch);
    if (branchTerm.length == 0) return this.sliceCompanyResult(companies);
    const branchID = this.getBranchIDFromTCOD(branchTerm);
    return this.sliceCompanyResult(companies.filter((c) => this.filterCompanyByBranch(c, branchTerm, branchID)));
  }

  sliceCompanyResult(companies: Company[]): FilterCompanyResult {
    const slicedCompanies = companies.slice(0, 40 * (this.pageCount + 1));
    return {
      companies: slicedCompanies,
      morePages: slicedCompanies.length < companies.length,
      total: companies.length
    };
  }

  filterCompanyByBranch(company: Company, searchTerm: string, branchID: number | null): boolean {
    if (!company.branchesSummaries) return false;
    const filteredBranch: FilteredBranch[] = [];
    company.branchesSummaries.forEach((e) => {
      const hasTerm = normalize((e.customerID ?? "") + "|" + e.name).includes(searchTerm);
      if (hasTerm || (branchID && e.id == branchID)) {
        filteredBranch.push({
          branch: e,
          name: e.name,
          tcod: !hasTerm ? searchTerm.trim().toUpperCase() : null,
          searchTerm: hasTerm ? searchTerm : null
        });
      }
    });
    company.filteredBranch = filteredBranch;
    if (filteredBranch.length > 0) return true;
    return false;
  }

  get currentCompanyLoading(): boolean {
    return this.$store.state.selectedCompanyLoading;
  }

  get currentUser(): User | null {
    return this.$store.state.currentUser;
  }

  get userPermission(): PartialPermission {
    return this.$store.getters.userPermission;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  get showUserAdmin(): boolean {
    if (!this.currentUser) {
      return false;
    }
    return (
      this.currentUser.isGlobalAdmin ||
      (this.currentUser.permissions && this.currentUser.permissions.some((p) => p.admin))
    );
  }

  get isLoading(): boolean {
    return this.userCompaniesLoading;
  }

  @Watch("txtCompanySearch")
  onSearchByCompanyChanged() {
    this.debounceUpdateSearch();
  }

  @Watch("txtBranchSearch")
  onSearchByBranchChanged() {
    this.debounceUpdateSearch();
  }

  debounceUpdateSearch = lodash.debounce(() => {
    this.updateSearchTerm();
  }, 300);

  updateSearchTerm() {
    console.log(`Updated searchterm ${this.txtCompanySearch} ${this.txtBranchSearch}`);
    if (this.fiterBy == "company") {
      this.searchByCompany = this.txtCompanySearch;
    } else {
      this.searchByBranch = this.txtBranchSearch;
    }
  }

  clearSearchTerms() {
    this.txtCompanySearch = "";
    this.searchByCompany = "";
    this.txtBranchSearch = "";
    this.searchByBranch = "";
  }

  getBranchIDFromTCOD(tcod: string): number | null {
    try {
      const result = util.parseTCOD(tcod);
      if (!result.branchID) return null;
      return result.branchID;
    } catch (e) {
      return null;
    }
  }

  cmdRetryLoadCompanies() {
    util.promiseEnd(this.$store.dispatch("refreshCompanies"));
  }

  cmdAddCompany() {
    this.$root.$emit("company-add");
  }

  cmdUserAdmin() {
    uiUtil.routePush(this, "/usermanager");
  }

  async cmdSelectCompany(company: Company) {
    await this.$store.dispatch("selectCompany", company);
    this.$router.push(getUserStartPage());
  }

  async cmdSelectBranch(
    company: Company,
    branch: FilteredBranch | null,
    page: null | "vending" | "info" | "transactions"
  ) {
    navigateToTerminal(this, page, company, branch?.branch, branch?.tcod);
  }

  get canRemoveCompanies() {
    return (
      !this.isLoading &&
      this.currentUser &&
      !this.currentUser.isGlobalAdmin &&
      this.userCompanies &&
      this.userCompanies.length > 1
    );
  }

  async cmdRemove(company: Company) {
    if (!this.canRemoveCompanies || !confirm(this.lang.deleteMerchantAlert)) {
      return;
    }
    this.removingCompany = company;
    const perm: EditPermission = {
      companyID: company.id,
      remove: true
    };
    const user: EditUser = {
      edit: true,
      uid: this.currentUser?.uid,
      permissions: [perm]
    };
    try {
      const savedResult = await domain.backend.saveUser(user);
      util.log("Usuario guardado", savedResult);
      this.removingCompany = null;
      this.cmdRetryLoadCompanies();
    } catch (error) {
      util.logError("Error guardando el usuario", error);
      this.removingCompany = null;
      this.snackbar = uiUtil.toErrorMsg(error, this.lang.failedToSaveUser);
    }
  }
}
